import {
  Box,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
  MenuItem,
  Icon,
  Menu,
  Container,
} from "@mui/material";
import React from "react";
import { useAuth } from "../../auth_provider";
import { useNavigate } from "react-router-dom";
import AppLogo from "../../app/assets/logo.png";

function DashboardLayout({ children }) {
  const auth = useAuth();

  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      <Box mb={5}>
        <AppBar color="transparent" position="sticky">
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
              onClick={() => {
                navigate("/dashboard");
              }}
            >
              <img src={AppLogo} alt="" height={"30vh"} />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Portal
            </Typography>
            <div>
              <IconButton
                size="large"
                color="inherit"
                onClick={() => navigate("/dashboard")}
              >
                <Icon>home</Icon>
              </IconButton>
            </div>
            <div>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <Icon>account_circle</Icon>
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                {/* <MenuItem onClick={handleClose}>Profile</MenuItem> */}
                <MenuItem onClick={() => navigate("/account")}>
                  My Account
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    auth.logOut();
                  }}
                >
                  Sign Out
                </MenuItem>
              </Menu>
            </div>
            {/* <div>
              <IconButton size="large" color="inherit">
                <Icon>logout</Icon>
              </IconButton>
            </div> */}
          </Toolbar>
        </AppBar>
      </Box>
      <Box mt={3}>
        <Container>
          <Box mb={5}>{children}</Box>
        </Container>
      </Box>
    </div>
  );
}

export default DashboardLayout;
